// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case {
    padding-top: 75px;
    @media screen and (max-width: 600px) {
     padding-top: 0;
      
     }
  }
  .case__container {
    width: 1150px;
    height: 100%;
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    align-items: center;
    @media screen and (max-width: 600px) {
      flex-direction: column;
      width: 100%;
      
     }
  }
  .case__left {
    display: flex;
    padding-top: 40px;
  }
  .case__right {
    display: flex;
    flex-direction: column;
    margin-left: 30px;
    width: 100%;
    @media screen and (max-width: 600px) {
      margin-left: 0;
      
     }
  }
  .case__title {
    text-align: left;
    color: #1e1c1a;
    font-family: Roboto;
    font-size: 28px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 50px;
    margin: 0;
  }
  .case__text {
    color: #1e1c1a;
    font-family: Roboto;
    font-size: 17px;
    letter-spacing: 0;
    line-height: 30px;
    text-align: left;
    margin-top: 20px;
    margin-bottom: 0;
  }
  .case__text-ai {
    font-weight: 600;
  }
  .case__list {
    margin-top: 24px;
  }
  .case__list-block{
      display: flex;
      margin-bottom: 12px;
  }
  .case__list-item {
    margin: 0;
    color: #1e1c1a;
    font-family: Roboto;
    font-size: 17px;
    letter-spacing: 0;
    line-height: 30px;
   
    text-align: left;
    margin-left: 12px;
  }
  .case__list-item b{
      font-weight: 600;
    }
  .case__list-dot{
      height: 5px;
      width: 8px;
      background-color: #E8483E;
      display: flex;
      min-width: 8px;
      margin-top: 12px;
      transform: skew(-20deg, 0deg);
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Case/Case.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB;KACC,cAAc;;KAEd;EACH;EACA;IACE,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB;MACE,sBAAsB;MACtB,WAAW;;KAEZ;EACH;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;IACX;MACE,cAAc;;KAEf;EACH;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;EACX;EACA;IACE,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;MACI,aAAa;MACb,mBAAmB;EACvB;EACA;IACE,SAAS;IACT,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;;IAEjB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;MACI,gBAAgB;IAClB;EACF;MACI,WAAW;MACX,UAAU;MACV,yBAAyB;MACzB,aAAa;MACb,cAAc;MACd,gBAAgB;MAChB,6BAA6B;EACjC","sourcesContent":[".case {\n    padding-top: 75px;\n    @media screen and (max-width: 600px) {\n     padding-top: 0;\n      \n     }\n  }\n  .case__container {\n    width: 1150px;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    margin: 0 auto;\n    align-items: center;\n    @media screen and (max-width: 600px) {\n      flex-direction: column;\n      width: 100%;\n      \n     }\n  }\n  .case__left {\n    display: flex;\n    padding-top: 40px;\n  }\n  .case__right {\n    display: flex;\n    flex-direction: column;\n    margin-left: 30px;\n    width: 100%;\n    @media screen and (max-width: 600px) {\n      margin-left: 0;\n      \n     }\n  }\n  .case__title {\n    text-align: left;\n    color: #1e1c1a;\n    font-family: Roboto;\n    font-size: 28px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 50px;\n    margin: 0;\n  }\n  .case__text {\n    color: #1e1c1a;\n    font-family: Roboto;\n    font-size: 17px;\n    letter-spacing: 0;\n    line-height: 30px;\n    text-align: left;\n    margin-top: 20px;\n    margin-bottom: 0;\n  }\n  .case__text-ai {\n    font-weight: 600;\n  }\n  .case__list {\n    margin-top: 24px;\n  }\n  .case__list-block{\n      display: flex;\n      margin-bottom: 12px;\n  }\n  .case__list-item {\n    margin: 0;\n    color: #1e1c1a;\n    font-family: Roboto;\n    font-size: 17px;\n    letter-spacing: 0;\n    line-height: 30px;\n   \n    text-align: left;\n    margin-left: 12px;\n  }\n  .case__list-item b{\n      font-weight: 600;\n    }\n  .case__list-dot{\n      height: 5px;\n      width: 8px;\n      background-color: #E8483E;\n      display: flex;\n      min-width: 8px;\n      margin-top: 12px;\n      transform: skew(-20deg, 0deg);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
